import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    this.setState({ error, errorInfo });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            backgroundColor: '#0f172a',
            color: '#ffffff',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            padding: '20px',
            boxSizing: 'border-box',
            fontFamily: 'system-ui, sans-serif',
          }}
        >
          <div
            style={{
              backgroundColor: '#1e293b',
              border: '2px solid #ea580c',
              borderRadius: '12px',
              padding: '40px',
              maxWidth: '500px',
              width: '100%',
              textAlign: 'center',
              boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.6)',
            }}
          >
            <div style={{ fontSize: '48px', marginBottom: '16px' }}>⚠️</div>
            <h2
              style={{
                margin: '0 0 16px 0',
                fontSize: '20px',
                fontWeight: '900',
                color: '#ea580c',
              }}
            >
              Something Went Wrong
            </h2>
            <p
              style={{
                fontSize: '14px',
                color: '#94a3b8',
                lineHeight: '1.6',
                marginBottom: '24px',
              }}
            >
              System recovered from a runtime anomaly. Our team has been notified. Please
              refresh the page to continue.
            </p>
            <button
              onClick={() => window.location.reload()}
              style={{
                padding: '12px 24px',
                backgroundColor: '#ea580c',
                color: '#ffffff',
                border: 'none',
                borderRadius: '6px',
                fontSize: '14px',
                fontWeight: '700',
                cursor: 'pointer',
                textTransform: 'uppercase',
                transition: 'background-color 0.2s',
                marginBottom: '16px',
              }}
              onMouseOver={(e) => (e.target.style.backgroundColor = '#c2410c')}
              onMouseOut={(e) => (e.target.style.backgroundColor = '#ea580c')}
            >
              Reload Page
            </button>
            <a
              href="https://wa.me/256790206354"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: 'inline-block',
                padding: '12px 24px',
                backgroundColor: '#25D366',
                color: '#ffffff',
                border: 'none',
                borderRadius: '6px',
                fontSize: '14px',
                fontWeight: '700',
                cursor: 'pointer',
                textDecoration: 'none',
                transition: 'background-color 0.2s',
              }}
              onMouseOver={(e) => (e.target.style.backgroundColor = '#128C7E')}
              onMouseOut={(e) => (e.target.style.backgroundColor = '#25D366')}
            >
              Contact Support
            </a>
            {this.state.error && (
              <details
                style={{
                  marginTop: '24px',
                  textAlign: 'left',
                  fontSize: '12px',
                  color: '#64748b',
                }}
              >
                <summary style={{ cursor: 'pointer', marginBottom: '8px' }}>
                  Error Details
                </summary>
                <pre
                  style={{
                    backgroundColor: '#0f172a',
                    padding: '12px',
                    borderRadius: '6px',
                    overflow: 'auto',
                    whiteSpace: 'pre-wrap',
                    wordBreak: 'break-word',
                  }}
                >
                  {this.state.error.toString()}
                  {this.state.errorInfo && this.state.errorInfo.componentStack}
                </pre>
              </details>
            )}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
